import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Chip
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import getStyles from './styles';

const MVPWhat = () => {
  const styles = getStyles();

  const includedFeatures = [
    'Standard 5-page website',
    'Responsive design for mobile & desktop',
    'SSL certificate',
    'Basic SEO setup',
    'Domain & hosting configuration'
  ];

  const addOns = [
    'E-commerce setup',
    'Custom integrations',
    'Multi-language support',
    'Advanced SEO & analytics'
  ];

  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Typography variant="h2" sx={styles.title}>
            What&apos;s Included
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            Everything you need to get started, with optional upgrades available
          </Typography>
        </Box>

        {/* Content Grid */}
        <Grid container spacing={4} justifyContent="center">
          {/* Standard Package */}
          <Grid item xs={12} md={6}>
            <Card sx={styles.standardCard}>
              <CardHeader
                titleTypographyProps={{ sx: styles.cardTitle }}
                subheaderTypographyProps={{ sx: styles.cardSubheader }}
                title="Standard Package"
                subheader="Delivered in 48 hours"
                sx={styles.standardHeader}
              />
              <CardContent sx={styles.cardContent}>
                {includedFeatures.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{
                      ...styles.featureItem,
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <Box sx={styles.featureIconContainer}>
                      <CheckCircle sx={styles.checkIcon} />
                    </Box>
                    <Typography sx={styles.featureText}>{feature}</Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Add-ons */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                ...styles.addonCard,
                animationDelay: '0.2s'
              }}
            >
              <CardHeader
                title={
                  <Box sx={styles.addonHeaderBox}>
                    <Typography variant="h4" sx={styles.addonTitle}>
                      Optional Add-Ons
                    </Typography>
                    <Chip label="Custom Quote" color="secondary" size="small" />
                  </Box>
                }
                subheader="Extend functionality as needed"
                subheaderTypographyProps={{ sx: styles.cardSubheader }}
              />
              <CardContent sx={styles.cardContent}>
                {addOns.map((addon, index) => (
                  <Box
                    key={index}
                    sx={{
                      ...styles.featureItem,
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <Box sx={styles.addonIconContainer}>
                      <CheckCircle sx={styles.checkIcon} />
                    </Box>
                    <Typography sx={styles.featureText}>{addon}</Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MVPWhat;
